.body {
  color: var(--color-ds-content-label);
}

.title,
.section-title,
.heading {
  color: var(--color-ds-content-primary);
}

.fees {
  color: var(--color-ds-content-primary);
}

.exhibit {
  background-color: var(--color-ds-surface-raised);
  border-color: var(--color-ds-border-default);
  border-style: solid;
}
